import { render } from "./CollapsedInfos.vue?vue&type=template&id=51a8da41"
import script from "./CollapsedInfos.vue?vue&type=script&lang=js"
export * from "./CollapsedInfos.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__